import { BUSINESS } from "@/data/site";
import { Reveal } from "@/components/site/Reveal";
import { ShieldCheck, Clock, Star, MapPin } from "lucide-react";

const STATS = [
  { icon: ShieldCheck, value: "Fully", label: "Insured & certified work", sub: "Public liability cover" },
  { icon: Clock, value: `${BUSINESS.yearsInBusiness}+`, label: "Years in business", sub: "Trusted across the region" },
  { icon: Star, value: BUSINESS.ratingValue, label: "Average review score", sub: `400+ happy customers` },
  { icon: MapPin, value: BUSINESS.jobsCompleted, label: "Jobs completed", sub: "Homes & businesses" },
];

export const TrustBand = () => (
  <section className="bg-paper border-y border-line" data-testid="trust-band">
    <div className="mx-auto max-w-[1400px] px-6 lg:px-10">
      <div className="grid grid-cols-2 lg:grid-cols-4">
        {STATS.map((s, i) => (
          <Reveal
            key={i}
            delay={i * 0.08}
            className="p-8 lg:p-12 border-line [&:nth-child(odd)]:border-r lg:[&]:border-r lg:[&:nth-child(4)]:border-r-0 border-b lg:border-b-0 [&:nth-child(3)]:border-r-0 lg:[&:nth-child(3)]:border-r"
          >
            <s.icon className="w-6 h-6 text-brand mb-6" strokeWidth={1.75} />
            <div className="font-heading text-5xl lg:text-6xl leading-none text-ink tracking-tight">
              {s.value}
            </div>
            <div className="mt-4 text-sm text-ink font-medium">{s.label}</div>
            <div className="text-xs text-ink-soft mt-1 font-mono tracking-wide">{s.sub}</div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
